import { useAtomValue } from "jotai";
import { sessionAtom } from "@zapier/canvas-state";
import { useCurrentAccountId } from "@zapier/identity";

// use useIsOwnerOrSuperAdmin if you need to check if a user is an owner or super admin only
export default function useIsOwnerAdminOrSuperAdmin() {
  const currentAccountId = useCurrentAccountId();
  const session = useAtomValue(sessionAtom);

  if (!session) return false;

  const accountRole = session.roles?.find(
    (role) => role.account_id === currentAccountId,
  );

  // admins can handle billing stuff but not delete everyone else's canvases like owners and super admins
  return (
    accountRole?.role === "owner" ||
    accountRole?.role === "admin" ||
    accountRole?.role === "super_admin"
  );
}
